/* eslint-disable import/no-anonymous-default-export */
export default(yearData=[],action)=>{
    switch (action.type) {
        case 'ALL_YEAR_DATA':
            return action.payload
        default:
            return yearData;
    }
}